import React from 'react';
import {Form,Radio, Select,Spin} from 'antd';
import style from './index.less';
import FilterForm from 'components/FilterForm';
import BaseRangePicker from 'components/BaseRangePicker';
import BaseRangeMonthPicker from 'components/BaseRangeMonthPicker';
import {connect} from 'react-redux';
import {getConsumptionApp} from 'actions/consumption';
import Datapanel from './Datapanel';

const Option = Select.Option;
const FormItem = Form.Item;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;


class BaseMultConsumption extends React.Component {


    state = {
        interval : 'day',
        selectAppKey:'no-limit',
        selectSku:'',
        appList:[],
        canSearch:false,
        loading:false
    }

    appMap = {};
    skuHashMap = {};

    constructor(props){
        super(props);
        this.state.selectSku = props.skuList[0].contract_type;
        props.skuList.forEach(item=>{
            this.skuHashMap[item.contract_type] = item;
        });

    }

    componentDidMount(){
        //获取用户app列表
        getConsumptionApp().then(res=>{
            const {selectSku} = this.state;
            //根据sku,筛选appkey
            res.forEach(item=>{
                if(!this.appMap[item.contract_type]){
                    this.appMap[item.contract_type] = [];
                }
                this.appMap[item.contract_type].push(item);
            });
            //自动搜索
            this.setState({appList:this.appMap[selectSku]||[],canSearch:true},()=>{
                this.datapanel && this.datapanel.resetChange();
            });

        });
    }

    onChange = (e)=>{
        this.setState({interval:e.target.value});
    }
    onAppChange = (value)=>{
        this.setState({selectAppKey:value});
    }

    onSkuChange = (value)=>{

        this.setState({
            selectSku:value,
            //切换sku，清理数据
            data:{},
            list:[],
            total:0,
            outUrl:'',
            chartData:[],
        },()=>{
            this.setState({appList:this.appMap[value]||[],selectAppKey:'no-limit'});
        });
    }

    handleSubmit = (e) => {
        if(e){
            e.preventDefault();
        }

        this.datapanel && this.datapanel.resetChange();
    }

    getSearchParams = ()=>{
        const _params = {};
        if(this.rangePicker){
            const selectTime = this.rangePicker.getSelectTime();
            _params.start_ts = parseInt(selectTime[0].format('X'),10);
            _params.end_ts = parseInt(selectTime[1].format('X'),10);
            _params.account_id = this.props.account.account_id;
            _params.interval = this.state.interval;
            _params.contract_type = [this.state.selectSku];
            if(this.state.selectAppKey === 'no-limit'){
                _params.api_keys = this.state.appList.map(item=>{
                    return item.api_key;
                });
            }else{
                _params.api_keys = [this.state.selectAppKey];
            }
        }
        return _params;
    }

    setLoading = (loading)=>{
        this.setState({loading});
    }

    render() {
        let time = <BaseRangePicker ref={(ref)=>this.rangePicker=ref}/>;
        if(this.state.interval === 'month'){
            time = <BaseRangeMonthPicker ref={(ref)=>this.rangePicker=ref}/>;
        }
        const dataPanelConfig = this.skuHashMap[this.state.selectSku];

        return (
            <div>
                <Spin spinning={this.state.loading} indicator={<div></div>}>
                    <div style={{marginBottom:22,marginTop:20}}>
                        <FilterForm layout="inline" onSubmit={this.handleSubmit} disabledSubmit={!this.state.canSearch}>
                            <FormItem
                                label="SKU"
                            >
                                <Select
                                    disabled={this.state.apikeys === null}
                                    value={this.state.selectSku}
                                    style={{ width: 140 }}
                                    dropdownMatchSelectWidth={false}
                                    onChange={this.onSkuChange}>
                                    {this.props.skuList.map(item=>{
                                        return <Option key={item.contract_type} value={item.contract_type}>{item.name}</Option>;
                                    })}
                                </Select>
                            </FormItem>
                            <FormItem
                                label="App"
                            >
                                <Select
                                    disabled={this.state.apikeys === null}
                                    value={this.state.selectAppKey}
                                    style={{ width: 140 }}
                                    dropdownMatchSelectWidth={false}
                                    onChange={this.onAppChange}>
                                    <Option value='no-limit'>all</Option>
                                    {this.state.appList.map(item=>{
                                        return <Option value={item.api_key}>{item.name}</Option>;
                                    })}
                                </Select>
                            </FormItem>
                            <FormItem
                                label="Time range"
                            >
                                <RadioGroup onChange={this.onChange} defaultValue={this.state.interval}>
                                    <RadioButton value="day">Daily statistics</RadioButton>
                                    <RadioButton value="month">Monthly statistics</RadioButton>
                                </RadioGroup>
                                <span className={style.line}>&nbsp;</span>
                                {time}
                            </FormItem>

                        </FilterForm>
                    </div>
                    <Datapanel
                        key={this.state.selectSku}
                        getSearchParams={this.getSearchParams}
                        ref={ref => this.datapanel = ref}
                        config={dataPanelConfig}
                        getInfoPromise={this.props.getInfoPromise}
                        setLoading={this.setLoading}
                    />
                </Spin>
            </div>
        );
    }

}


function select(state) {
    return {
        account: state.account.info
    };
}
export default connect(select)(BaseMultConsumption);



// WEBPACK FOOTER //
// ./src/components/BaseMultConsumption/index.js